import { fileUploadStatus } from './constants';
import { findIndex, some } from 'lodash';
import { gatewayTypes } from 'helpers/constants';

export const containsNewFile = (bulkFiles) => {
	return findIndex(bulkFiles, (file) => { return file.uploadStatus === fileUploadStatus.NEW; }) >= 0;
};

export const getBulkUploadDeviceTypeLabel = (selectedAsset) => {
	switch (selectedAsset?.gatewayType) {
		case gatewayTypes.EGW02:
			return 'EGW-02';
		case gatewayTypes.NETA21:
		default:
			return 'NETA-21';
	}
};

export const checkUploadedFiles = (bulkFiles) => {
	return !some(bulkFiles, (file) => file.uploadStatus !== fileUploadStatus.SUCCESS);
};

export const uploadBulkUploadBlobStorage = (blobURl, file) => {
	return fetch(blobURl, { method: 'PUT', body: file, headers: { 'x-ms-blob-type': 'BlockBlob' } }).then(() => {
		return true;

	}).catch((error) => {
		console.log('error', error);
	});
};
